<template>
    <div>
        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>{{$t('i18n.fota_update')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('i18n.gray_test')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="app-container" >
            <el-card class="filter-container" shadow="never">
                <div>
                     <el-select      v-model="queryInfo.designName"      :placeholder="$t('i18n.choose_design')"      :filterable="true"      clearable @change="handleSelectionChange"  >
                        <el-option     v-for="item in designCompanyList"     :key="item.value"     :label="item.label"     :value="item.label" ></el-option>
                    </el-select>
                     <el-select   style="padding-left:10px"   v-model="queryInfo.brandName"     :placeholder="$t('i18n.choose_brand')"     :filterable="true"     clearable @change="handleSelectionChange" >
                         <el-option v-for="item in brandList"      :key="item.value"      :label="item.label"      :value="item.label"  ></el-option>
                     </el-select>
                    <el-select  style="padding-left:10px" v-model="queryInfo.projectName"      :placeholder="$t('i18n.choose_project')"      :filterable="true"      clearable @change="handleSelectionChange"  >
                       <el-option      v-for="item in projectlist"      :key="item.value"      :label="item.label"      :value="item.label"  ></el-option>
                    </el-select>
                    <span style="padding-left:20px">
                        <el-col :span="3">
                          <el-input :placeholder="$t('i18n.column.like_search')" v-model="queryInfo.keywords" @keyup.enter.native="likeSearch" clearable @clear="likeSearch">
                              <el-button slot="append" icon="el-icon-search" @click="likeSearch"></el-button>
                          </el-input>
                        </el-col>
                        <el-button  type="primary" round   @click="handleResetSearch()"    size="mini">{{$t('i18n.reset')}}</el-button>
                        <el-button     type="primary" round     @click="addDialogVisible=true"     size="mini" >{{$t('i18n.add_imei')}}</el-button>
                        <el-button     type="primary" round     @click="importDialogVisible=true"     size="mini" >{{ $t('i18n.batch_import_imei')}}</el-button>
                        <el-button  type="primary" round   @click="imeiTemplateDownLoad()"     size="mini" >{{ $t('i18n.download_excel_template')}}</el-button>
                        <el-button    @click="delDialogVisible=true"    type="danger" round    size="mini" icon="el-icon-delete">{{ $t('i18n.delete_imei_by_project')}}</el-button>
                    </span>
                </div>
                
            </el-card>

            <!-- 指定项目添加IMEI的对话框 -->
            <el-dialog   :title="$t('i18n.add_imei')"     :visible.sync="addDialogVisible"     width="50%"     @close="addDialogClose" >
                <!-- 内容主体区域 -->
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
                    <el-form-item :label="$t('i18n.choose_project')" label-width="120px" prop="projectId">
                        <el-select  v-model="addForm.projectId"  :placeholder="$t('i18n.choose_project')"  filterable  style="width: 100%" >
                            <el-option v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="IMEI" prop="imei" label-width="120px"  >
                         <el-input v-model="addForm.imei" placeholder="IMEI"  ></el-input>
                     </el-form-item>
                </el-form>
                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="addImei">{{$t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>

                   <!-- 删除指定项目IMEI的对话框 -->
            <el-dialog   :title="$t('i18n.delete_imei_by_project')"    :visible.sync="delDialogVisible"     width="50%"     @close="delDialogClose" >
                <!-- 内容主体区域 -->
                <el-form :model="delForm" :rules="delFormRules" ref="delFormRef" label-width="70px">
                    <el-form-item :label="$t('i18n.choose_project')" label-width="120px" prop="projectId">
                        <el-select  v-model="delForm.projectId"  :placeholder="$t('i18n.choose_project')"  filterable  style="width: 100%" >
                            <el-option v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="delDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="delImeiByProject">{{$t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>



       <!-- 批量导指定项目IMEI的对话框 -->
            <el-dialog   :title="$t('i18n.batch_import_imei')"    :visible.sync="importDialogVisible"     width="50%"     @close="importDialogClose" >
                <!-- 内容主体区域 -->
                <el-form :model="importForm" :rules="importFormRules" ref="importFormRef" label-width="70px">
                    <el-form-item :label="$t('i18n.choose_project')" label-width="120px" prop="projectId">
                        <el-select  v-model="importForm.projectId"  :placeholder="$t('i18n.choose_project')"  filterable  style="width: 100%" >
                            <el-option v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                
                <el-upload  class="upload-border-none"    ref="upload" action="/api/imeiTest/excelImport" :headers="{'sessionKey':sessionKey}" :data="importForm" :limit="1"  :before-upload="handleBefore" 
                    :on-success="handleSuccess" accept=".xls,xlsx"   :auto-upload="false" :file-list="fileList" >
                        <el-button   size="small" style="display:block;margin:0 auto" type="primary">{{$t('i18n.choose_file')}}</el-button>
                </el-upload>

                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="importDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="importImeiByProject">{{$t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>


        </div>

    


        <div class="table-container">
            <!-- table表格区域 -->
            <el-table :data="imeiList" border stripe>
                <!-- <el-table-column type="index"></el-table-column> -->
                <el-table-column label="ID" width="80px" prop="id"></el-table-column>
                <el-table-column :label="$t('i18n.column.design')" prop="designName"  ></el-table-column>
                <el-table-column :label="$t('i18n.column.brand')" prop="brandName" ></el-table-column>
                <el-table-column :label="$t('i18n.column.project')" prop="projectName" width="330px"></el-table-column>
                <el-table-column label="IMEI" prop="imei"></el-table-column>
                <el-table-column :label="$t('i18n.column.update_time')" prop="updateTime"></el-table-column>
                 <el-table-column :label="$t('i18n.column.is_enabled')" prop="status"  > 
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="handleUpdateStatus(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="是否黑名单" prop="status"  > 
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.blackFlag" :active-value="1" :inactive-value="0" @change="handleBlack(scope.row)"></el-switch>
                    </template>
                </el-table-column> -->
                <el-table-column :label="$t('i18n.column.operator')" width="260px">
                    <template slot-scope="scope">
                        <el-button type="danger" circle icon="el-icon-delete" size="mini" @click="handleDeleteImeiTest(scope.row)">
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginnation-container">
            <!-- 分页区域 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNo"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { deleteIemiTestById,createImeiTest,deleteIemiTestByProjectId,resetAllStatus,resetStatusById } from '@/api/imeiTest';
import { resetBlackByProjectIdAndImei } from '@/api/imeiBlackWhite';
import axios from 'axios'

const defaultListQuery = {
    versionId: null,
    brandName: '',
    productName: '',
    designName: '',
    projectName: '',
    keywords: '',
    pageNo: 1,
    pageSize: 15
};

export default {
    data() {
        return {
            // 查询参数对象
            // 项目列表
            imeiList:[],
            projectlist: [],
            // 总数据条数
            totalSize: 0,
            brandList: [],
            designCompanyList: [],
            queryInfo: Object.assign({}, defaultListQuery),
            // 控制添加项目对话框的显示与隐藏
            addDialogVisible: false,
            delDialogVisible: false,
            importDialogVisible: false,
            // 添加项目的表单数据
            addForm: {
                projectId: '',
                imei: ''
            },
            delForm: {
                projectId: '',
            },
            importForm: {
                projectId: '',
            },
            // 添加表单的验证规则对象
            addFormRules: {
                projectId: [{ required: true, message:this.$t('i18n.validate.project_need'), trigger: 'blur' }],
                imei: [{ required: true, message: this.$t('i18n.validate.iemi_need'), trigger: 'blur' }],
            },
             // 添加表单的验证规则对象
            delFormRules: {
                projectId: [{ required: true, message: this.$t('i18n.validate.project_need'), trigger: 'blur' }],
            },
              // 添加表单的验证规则对象
            importFormRules: {
                projectId: [{ required: true, message: this.$t('i18n.validate.project_need'), trigger: 'blur' }],
            },
            fileList: [],
        
        };
    },
    created() {
        this.getProjectList();
        this.getBrandList();
        this.getDesignCompanyList();
        this.getImeiList();
        this.sessionKey=localStorage.getItem("sessionKey")
    },
    methods: {
        getImeiList() {
            this.$http
                .get('/imeiTest/queryPage', {
                    params: this.queryInfo
                })
                .then(res => {
                    res = res.data;
                    // console.log('测试IMEI返回', res);
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    this.imeiList = res.data.list;
                    this.totalSize = res.data.totalSize;
                });
        },
        
        likeSearch(){
            this.queryInfo.pageNo=1
            this.getImeiList()

        },

        handleSelectionChange(){
            this.getImeiList()
        },
        // 根据分页获取对应的项目列表
        getProjectList() {
            this.$http
                .get('/project/queryAll', {
                   
                })
                .then(res => {
                    res = res.data;
                    // console.log('返回结果',res)
                    //      console.log('项目列表查询',res.data.list)
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    this.projectlist = [];
                    let projectlist = res.data;
                    for (let i = 0; i < projectlist.length; i++) {
                        this.projectlist.push({ label: projectlist[i].projectName, value: projectlist[i].id });
                    }
                });
        },

        getBrandList() {
            this.$http
                .get('/brand/queryPage', {
                    params: this.queryInfo
                })
                .then(res => {
                    res = res.data;
                    this.brandList = [];
                    // console.log('品牌信息返回',res)
                    let brandList = res.data.list;

                    for (let i = 0; i < brandList.length; i++) {
                        this.brandList.push({ label: brandList[i].brandName, value: brandList[i].id });
                    }
                    // console.log('品牌信息列表',brandList)
                });
        },

        getDesignCompanyList() {
            this.$http
                .get('/designCompany/queryPage', {
                    params: this.queryInfo
                })
                .then(res => {
                    res = res.data;
                    this.designCompanyList = [];
                    let designCompanyList = res.data.list;
                    for (let i = 0; i < designCompanyList.length; i++) {
                        this.designCompanyList.push({ label: designCompanyList[i].designName, value: designCompanyList[i].id });
                    }
                    // console.log('设计公司列表',designCompanyList)
                });
        },

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getImeiList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNo = newPage;
            this.getImeiList();
        },
        async handleDeleteImeiTest(row) {
            console.log('----当前------', row);
            const confirmResult = await this.$confirm(this.$t('i18n.is_delete_continue'), this.$t('i18n.tip'), {
                confirmButtonText: this.$t('i18n.confirm'),
                cancelButtonText: this.$t('i18n.cancel'),
                type: 'warning'
            }).catch(err => {
                console.log('删除测试IMEI', err);
                return err;
            });

            if (confirmResult !== 'confirm') {
                return this.$message.info(this.$t('i18n.had_cancel_delete'));
            }
            const { data: res } = await deleteIemiTestById(row.id);
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(this.$t('i18n.success'));
            this.getImeiList()
            
        },

           async handleUpdateStatus(row){
                const {data:res}=  await resetStatusById(row.id,row.status)
                if(res.code!=0){
                    if(row.status===0){
                    row.status=1
                    }else{
                    row.status=0
                    }
                    return this.$message.error(res.msg)
                }
              
        },
      
         imeiTemplateDownLoad(){
             axios.get('/template/download?templateName=imeiTestImportTemplate',{responseType:'arraybuffer'}).then((res)=>{
                let fileName=decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1])//获取头里的文件名
                let blob =new Blob([res.data],{type:"application/vnd.ms-excel"});//获取文件数据
                let objectUrl=URL.createObjectURL(blob);
                const link=document.createElement('a')
                link.href=objectUrl
                link.download=fileName;
                link.click();//下载文件
                URL.revokeObjectURL(objectUrl);//释放内存
             }).catch(function(res){})
        },

          async handleBlack(row){
                const {data:res}=  await resetBlackByProjectIdAndImei(row.projectId,row.imei,row.blackFlag)
                if(res.code!=0){
                    if(row.blackFlag===0){
                    row.blackFlag=1
                    }else{
                    row.blackFlag=0
                    }
                    return this.$message.error(res.msg)
                }
              
        },

        projectCreate() {
            this.$router.push('/project/create');
        },
       
        // 重置
        handleResetSearch() {
            this.queryInfo = Object.assign({}, defaultListQuery);
            this.getImeiList()
        },

        // 监听添加IEMI对话框的关闭事件
        addDialogClose() {
            this.$refs.addFormRef.resetFields();
        },
         // 监听添加IEMI对话框的关闭事件
        delDialogClose() {
            this.$refs.delFormRef.resetFields();
        },
        
         // 监听添加IEMI对话框的关闭事件
        importDialogClose() {
            this.$refs.importFormRef.resetFields();
            this.fileList=[]
        },
        // 点击按钮，添加新IEMI
        addImei() {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return;
                // 可以发起添加IMEI的网络请求
                const { data: res } = await this.$http.post('/imeiTest/create', this.addForm);
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                }
                // 隐藏添加IEMI的对话框
                this.addDialogVisible = false;
                // 重新获取IEMI列表数据
                this.getImeiList()
            });
        },
          // 点击按钮，删除指定项目IMEI
        delImeiByProject() {
            this.$refs.delFormRef.validate(async valid => {
                if (!valid) return;
                 const confirmResult = await this.$confirm(this.$t('i18n.is_delete_continue'), this.$t('i18n.tip'), {
                confirmButtonText:this.$t('i18n.confirm'),
                cancelButtonText: this.$t('i18n.cancel'),
                type: 'warning'
                }).catch(err => {
                    console.log('删除IMEI异常', err);
                    return err;
                });
                if (confirmResult !== 'confirm') {
                     this.delDialogVisible = false;
                    return this.$message.info(this.$t('i18n.had_cancel_delete'));
                }
                // 可以发起添加IMEI的网络请求
                const { data: res } = await this.$http.post('/imeiTest/deleteByProjectId/'+this.delForm.projectId);
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                }
                // 隐藏添加IEMI的对话框
                this.delDialogVisible = false;
                // 重新获取IEMI列表数据
                this.getImeiList()
            });
        },
            // 点击按钮，导入指定项目IMEI
        importImeiByProject() {
            this.$refs.importFormRef.validate(async valid => {
                if (!valid) return;
                this.$refs.upload.submit();
            });
        },
        // 上传前的回调函数
    　　handleBefore(file) {
    　　　 
    　　},
        // 上传成功回调
    　　handleSuccess(res) {
        this.$refs.upload.clearFiles()
        if(res.code==0){
            this.importDialogVisible = false;
            this.$message.success(this.$t('i18n.success'));
            this.getImeiList()
        }else{
            this.$message.error(this.$t('i18n.fail'));
        }
    　},
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
    
    },
  
};
</script>

<style >
    .el-pagination {
            text-align: right; 
    }
/* .paginnation-container {
    position: fixed;
    
     left: 40%;
     bottom: 0%
}
.filter-container{
    height:65px
} */
 .upload-border-none{
    border:none!important
  } 

</style>
